import React from 'react';
import CloseWindowButton from '../../buttons/closeWindow/CloseWindowButton';
import PropTypes from 'prop-types';
import style from './TagInput.module.css';



function Tag({ children, closeHandler, index }) {
  return (
    <div className={style.tagContainer}>
      <span className={style.tagText}>{children}</span>
      <CloseWindowButton
        width={8}
        stroke={1}
        color="black"
        handleClick={() => closeHandler(index)}
        display="inline"
        margin=" 0 0 3px 2px"
      />
    </div>
  );
}

Tag.propTypes = {
  children: PropTypes.any.isRequired,
  closeHandler: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
};

export default Tag;
